// Mixin de selección múltiple para las vistas de asignación (capas / usuarios / geoprocesos).
// Mantiene dos listas de ids seleccionados (disponibles y asignados) y helpers puros.
// Cada vista pasa sus propios arrays a estos métodos: no conoce la entidad concreta.
export const assignSelection = {
    data() {
        return {
            selAvailable: [],
            selAssigned: []
        }
    },
    methods: {
        isSelected(selection, id) {
            return selection.indexOf(id) !== -1;
        },
        toggleSelection(selection, id) {
            var index = selection.indexOf(id);
            if (index === -1) {
                selection.push(id);
            } else {
                selection.splice(index, 1);
            }
        },
        allSelected(list, selection) {
            return !!(list && list.length) && list.every(function(item){
                return selection.indexOf(item.id) !== -1;
            });
        },
        toggleSelectAll(selection, list) {
            var current = list || [];
            if (this.allSelected(current, selection)) {
                current.forEach(function(item){
                    var index = selection.indexOf(item.id);
                    if (index !== -1) {
                        selection.splice(index, 1);
                    }
                });
            } else {
                current.forEach(function(item){
                    if (selection.indexOf(item.id) === -1) {
                        selection.push(item.id);
                    }
                });
            }
        },
        // Intersección: solo los seleccionados que además están visibles ahora
        selectedItems(list, selection) {
            return (list || []).filter(function(item){
                return selection.indexOf(item.id) !== -1;
            });
        }
    }
}
